
	import {
		Component,
		Vue
	} from 'vue-property-decorator';
	import RadioButton from '@/components/radio-button.vue';
	import PageFooter from '@/components/page-footer.vue';
	import PickerDate from '@/components/picker-date.vue';
	import {
		grade
	} from '@/utils/config';
	import userDetailDialog from './components/user-detail-dialog.vue';
	import Message from '@/components/message.vue';
	import Dialog from '@/components/dialog.vue';
	import {
		getUserId
	} from '@/utils/storage'
	import {
		getAgentUserList,
		setBlackMember,
		checkMembers,
		memberAuthInfoByPhone,
		changeRecommend,
		membersaveCustomerInfo,
		getAgentUserDetail,
		membermemberCancelAuth
	} from '@/api/agent_user'
	import {
		UserModule
	} from "@/store/modules/user"

	@Component({
		name: 'member-list',
		components: {
			RadioButton,
			PageFooter,
			userDetailDialog,
			'slz-message': Message,
			'slz-dialog': Dialog,
			PickerDate
		}
	})
	export default class MemberList extends Vue {
		private defaultAvatar = 'https://cdn2024.shiwuzone.com/routuan/image/20230110-0f54988a-9589-45bc-ad27-844c60e80f36.png'
		private list: any = [];
		private pageNo = 1;
		private pageSize = 20;
		private total = 0;
		private DistributorCount = 0;
		private IDKey = '';
		private memberKey = '';
		private upmemberKey = '';
		private RelationType = 0;
		private phoneKey = '';
		private radioType = null;
		private showDetailBox = false;
		private radioList: any = [{
				label: '全部',
				value: null
			}, {
				label: '待审核',
				value: 1
			}, {
				label: '已通过',
				value: 2
			}, {
				label: '已拉黑',
				value: -1
			}
		];
		private fullGrade = grade;
		private gradeType = null;
		private gradeList = [{
				label: '全部',
				value: null
			}, {
				label: 'VIP',
				value: 3
			}, {
				label: 'VIC',
				value: 2
			}, {
				label: 'SVIC',
				value: 1
			}, {
				label: '客户',
				value: 0
			}
		];
		private currentId = 0;
		private currentUpId = 0;
		private msgTitle = '';
		private msgContent = '';
		private showMessage = false;
		private msgType = 0;
		private showCheckMessage = false;
		private showReject = false;
		private refuseDetail = '';
		private handleType = 0;

		private refereesShow = false
		private changeId = 0
		private refereesphone = ''
		private refereesmsg:any = {}

		private level = null

		private rowmsg:any = {}

		private changeinfoShow = false
		private changeinfoMsg = {
			MemberId:0,
			Phone:'',
			WeixinId:'',
			UnionId:'',
		}
		private tableloading=false
		private IsShowExportButton = false

		private becomeShow = false


		mounted (){
			// this.getList();
		}
		activated () {
			this.getList();
		}

		get userId(){
			return Number(UserModule.mallInfo.EmployeeId)
		}


		private async tobecome(){
			try{
				this.tableloading = true
				let res:any = await membermemberCancelAuth({
					MemberId:this.changeId
				})
				if(res.IsSuccess){
					this.$message.success('操作成功')
					this.getList()
				}
			}finally{
				this.tableloading = false
			}
		}
		private exportfile(){
			let url = location.origin + '/pc/member/memberPageListExport'
			url += '?Keywrods=' + encodeURIComponent(this.memberKey)
			url += '&RelationKeywords=' + encodeURIComponent(this.upmemberKey)
			url += '&MemberId=' + this.IDKey
			url += '&State=' + (this.radioType==null?'':this.radioType)
			url += '&RoleGrade=' + (this.gradeType==null?'':this.gradeType)
			url += '&RelationType=' + (this.RelationType==null?'':this.RelationType)
			window.open(url)

		}
		private toCreate() {
			this.$router.push({
				name: 'add_member'
			})
		}

		private async confirmchangeinfo(){
			if(!this.changeinfoMsg.Phone){
				this.$message.error('请输入手机号')
				return 
			}else if(this.changeinfoMsg.Phone.length>15||this.changeinfoMsg.Phone.length<6){
				this.$message.error('请输入正确的手机号')
				return 
			}

			try{
				let data = JSON.parse(JSON.stringify(this.changeinfoMsg))
				let res = await membersaveCustomerInfo(data)
				if(res.IsSuccess){
					this.$message.success('修改成功')
					this.closechangeinfo()
					this.getList()
				}
			}finally{
				//
			}
		}

		private closechangeinfo(){
			this.changeinfoShow = false
			this.changeinfoMsg = {
				MemberId:0,
				Phone:'',
				WeixinId:'',
				UnionId:'',
			}
		}

		private async changephone(row){
			try{
				const res: any = await getAgentUserDetail({
          MemberId: row.Id,
        })
				if(res.IsSuccess){
					console.log(res)
					this.changeinfoShow = true
					this.changeinfoMsg = {
						MemberId:row.Id,
						Phone:res.Result.Phone,
						WeixinId:res.Result.WeixinId,
						UnionId:res.Result.UnionId,
					}
				}
			}finally{
				//
			}
		}

		private async confirmreferee(){
			if(!this.refereesmsg.Id){
				this.$message.error('请选择新推荐人')
				return 
			}

			try{
				let res = await changeRecommend({
					MemberId:this.changeId,
					NewRecommendId:this.refereesmsg.Id
				})
				if(res.IsSuccess){
					this.$message.success('操作成功')
					this.closereferees()
					this.getList()
				}
			}finally{
				//
			}
		}

		private closereferees(){
			this.refereesphone = ''
			this.refereesmsg = {}
			this.refereesShow = false
		}

		private async searchreferees(){
			if(!this.refereesphone){
				this.$message.error('请输入手机号')
				return
			}
			

			try{
				let res = await memberAuthInfoByPhone({
					Phone:this.refereesphone
				})

				if(res.IsSuccess){
					// console.log(res.Result)
					this.refereesmsg = res.Result || {}
				}
			}finally{
				//
			}

		}

		private handleCommand(e){
			// console.log(e)
			if(e.type==='changereferees'){
				this.refereesShow = true
				this.changeId = e.Id
			}else if(e.type==='edit'){
				this.toDetail('',e.Id)
			}else if(e.type=='changecustomer'){
			if(!this.testStanding(e.row)) return 
				this.becomeShow = true
				this.changeId = e.Id
				this.rowmsg = e.row
			}
		}
		private testStanding(row){
			if(row.IsPullBlack){
				this.$message.error('请先恢复账号为正常状态')
				return false
			}
			if(row.RoleGrade!=3){
				this.$message.error('该功能仅支持VIP')
				return false
			}
			return true
		}
		private doOperate(type: number, user_id: number,row:any) {
			this.currentId = user_id;
			this.rowmsg = row
			this.msgType = type;
			this.msgTitle = '提示';
			this.showMessage = true
			if (type) {
				this.msgContent = '确认拉黑该分销员账号？'
			} else {
				this.msgContent = '确认恢复该分销员账号？'
			}
		}

		private async confirmBlack() {
			try {
				await setBlackMember({
					MemberId: +this.currentId,
					IsPullBlack: this.msgType === 1 ? true:false
				})
				this.$message({
					type: 'success',
					message: '设置成功！'
				})
				this.getList();
			} catch (e) {
				console.log(e)
			}
		}

		/**
		 * 点击通过
		 */
		private handleCheck(id: number, up_user_id: number) {
			this.handleType = 1;
			this.currentId = id;
			this.showCheckMessage = true;
		}

		/**
		 * 点击驳回
		 */
		private handleReject(id: number, up_user_id: number) {
			this.handleType = 2;
			this.currentId = id;
			this.showReject = true;
		}

		private async confirmCheck() {
			try {
				await checkMembers({
					MemberId: +this.currentId,
					IsCheckPass: this.handleType === 1 ? true:false,
				})
				let msgText = ''
				if (this.handleType === 1) {
					msgText = '已通过'
				} else if (this.handleType === 2) {
					msgText = '已驳回'
				}
				this.$message({
					type: 'success',
					message: msgText
				})
				this.currentUpId = 0;
				this.getList();
			} catch (e) {
				console.log(e)
			}
		}

		private showDetail(row: any) {
			// console.log(row)
			this.currentId = row.Id
			this.level = row.RoleGrade
			this.showDetailBox = true;
		}

		// 跳转到详情编辑页面
		private toDetail(e: any, id: number) {
			// console.log(id)
			this.$router.push({
				name: 'Member_Detail',
				query: {
					type: 'edit',
					id: id + ''
				}
			})
		}

		// 搜索
		private doSearch() {
			this.pageNo = 1;
			this.getList();
		}

		// 清空搜索
		private clearSearch() {
			this.pageNo = 1;
			this.radioType = null;
			this.gradeType = null;
			this.memberKey = '';
			this.IDKey = '';
			this.upmemberKey = '';
			this.phoneKey = '';
			this.getList();
		}

		private changePage(num: number) {
			this.pageNo = num;
			this.getList();
		}

		// 获取列表
		private async getList() {
			let params: any = {
				Skip: (this.pageNo-1)*this.pageSize,
				Take: this.pageSize,
				State: this.radioType,
				RoleGrade: this.gradeType,
				RelationType:this.RelationType,
				// RelationKeywords:'',
				Keywrods: this.memberKey,
				RelationKeywords: this.upmemberKey,
				MemberId: this.IDKey,
			}
			
			try {
				this.tableloading=true
				const res: any = await getAgentUserList(params)
				this.list = res.Result.Results;
				this.total = res.Result.Total;
				this.DistributorCount  = res.Result.DistributorCount
				this.IsShowExportButton = res.Result.IsShowExportButton
			} catch (e) {
				console.log(e)
			} finally{
				this.tableloading=false
			}
		}
	}
